import { SliderFilter } from 'shared/components/slider/SliderFilter';
import type { ApiQueryParams } from '@/interfaces';

export interface DistanceSliderStateProps {
    id: string;
    label: string;
    min: number;
    max: number;
    initialDistance?: number;
}

export interface DistanceSliderDispatchProps {
    distanceChange: (newDistance?: number) => void;
    triggerFetch: (queryParam?: ApiQueryParams) => void;
}

export type DistanceSliderProps = DistanceSliderStateProps & DistanceSliderDispatchProps;

export const DistanceSlider = ({ id, label, min, max, initialDistance, distanceChange, triggerFetch }: DistanceSliderProps) => {
    const step = 50;
    const distanceWithStep = Math.round((initialDistance || max) / step) * step;

    const updateState = (value: number): void => {
        if (value !== max) {
            distanceChange(value);
        } else {
            distanceChange(undefined);
        }
        triggerFetch();
    };

    return (
        <SliderFilter
            id={`distanceSlider-${id}`}
            label={label}
            value={distanceWithStep}
            affix="m"
            min={min}
            max={max}
            step={step}
            renderValue={(num) => `${num} meter`}
            onChange={updateState}
        />
    );
};
